<template>
  <div class="diceBg" :class="{'part': $route.meta.text == '파트너 페이지', 'dashboard-root': $route.name === 'main'}">
    <div class="diceBgDark dice" :class="{'dashboard-shell': useEditorialShell, 'subpage-shell': useEditorialShell && $route.name !== 'main'}">
      <main-header v-if="useEditorialShell" :selectedMenu="selectedMenu" />
      <div class="content0" :class="{'sub': $route.name !== 'main'}">
        <router-view :key="$route.fullPath"></router-view>
        <main-footer v-if="banner" />
      </div>
    </div>
  </div>

  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" :code="code" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>
import MainHeader from './Header'
import MainFooter from './Footer'
import SlotList from '@/components/game/SlotList'
import { mapState } from 'vuex'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Loading,
    SlotList,
    MainHeader,
    MainFooter
  },
  computed: {
    ...mapState([
      'banner'
    ]),
    useEditorialShell () {
      return ![
        'partnerCashList',
        'partnerBettingList',
        'partnerList',
        'partnerCalculationList',
        'partnerCalculationUserList',
        'partnerMemberList',
        'partnerMoneyMoveList'
      ].includes(this.$route.name)
    }
  },
  mounted () {
    this.syncDashboardBodyClass()
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        const code = data.code
        this.getSlotOpen(groupCode, codeName, code)
      } else {
        this.isSlotOpen = false
      }
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeMount () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeUnmount () {
    document.body.classList.remove('mega09-editorial-body')
  },
  watch: {
    '$route.name' () {
      this.syncDashboardBodyClass()
    }
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: '',
      code: '',
      isLoading: false,
      selectedMenu: ''
    }
  },
  methods: {
    syncDashboardBodyClass () {
      document.body.classList.toggle('mega09-editorial-body', this.useEditorialShell)
    },
    scrollToSection (menu) {
      const sectionId = menu.replace(/ /g, '')
      const sectionElement = document.getElementById(sectionId)
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll () {
      const sectionElements = document.querySelectorAll('section')
      const selectedSection = Array.from(sectionElements).find((section) => {
        const rect = section.getBoundingClientRect()
        return rect.top <= 0 && rect.bottom > 0
      })
      if (selectedSection) {
        this.selectedMenu = selectedSection.id
      }
    },
    getSlotOpen (groupCode, codeName, code) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.code = code
        this.isSlotOpen = true
      } else {
        this.onCheck('front.error.afterSignin')
      }
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'GmarketSans';
  src: url('../assets/fonts/gmarket-main/GmarketSansLight.woff2') format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'GmarketSans';
  src: url('../assets/fonts/gmarket-main/GmarketSansMedium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'GmarketSans';
  src: url('../assets/fonts/gmarket-main/GmarketSansBold.woff2') format('woff2');
  font-weight: 700 900;
  font-style: normal;
  font-display: swap;
}
/* .diceBg {background: url(../assets/img/main_bgobj.png) repeat; background-size: 10%;} */
.diceBgDark {width: 100%; height: 100%;}
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in;
}

.fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.part {background: #fff;}
.sub {background: url(../assets/img/sub-bg.jpg) center no-repeat;background-size: cover;}

/* MEGA main-only compact navigation */
.dashboard-shell,
.dashboard-shell button,
.dashboard-shell input,
.dashboard-shell select,
.dashboard-shell textarea {
  font-family: 'GmarketSans', sans-serif;
}
.dashboard-shell .leftHeader {
  width: 148px;
  min-width: 148px;
  padding: 0 10px;
  background: linear-gradient(180deg, #11131a 0%, #090a0e 100%);
  border-right: 1px solid #292b33;
  box-shadow: 14px 0 35px rgba(0, 0, 0, .28);
  overflow: visible;
}
.dashboard-shell .content0 {
  width: calc(100% - 148px);
}
.dashboard-shell header.side {
  padding-left: 168px;
}
@media (max-width:1000px) {
  .dashboard-shell {display:block;background:#0c0c0e!important}
  .dashboard-shell .content0 {width:100%;max-width:100%;margin:0;background:#0c0c0e}
  .dashboard-shell .leftHeader {display:none}
  .dashboard-shell header.side {padding-left:0}
}
.dashboard-shell .leftHeader .logowrap {
  height: 82px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard-shell .leftHeader .logowrap a {
  width: 54px;
  height: 54px;
  border: 1px solid #b79045;
  border-radius: 16px;
  background: linear-gradient(145deg, #2f2719, #15161c);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard-shell .leftHeader .logowrap a::after {
  content: 'M';
  color: #e2bd68;
  font-family: Georgia, serif;
  font-size: 28px;
  font-weight: 800;
}
.dashboard-shell .leftHeader .logowrap img {
  display: none;
}
.dashboard-shell .leftNav {
  padding: 12px 0 0;
  gap: 9px;
}
.dashboard-shell .leftNav > ul {
  position: relative;
}
.dashboard-shell .leftNav > ul.utility-nav {display:flex}
.dashboard-shell .leftNav > ul.utility-nav.money-nav {
  order:10;
  margin-top:14px!important;
  padding-top:14px;
  border-top:1px solid #29292d;
}
.dashboard-shell .leftNav > ul.utility-nav.account-nav {order:11}
.dashboard-shell .leftNav > ul.utility-nav.support-nav {order:12}
.dashboard-shell .leftNav > ul.utility-nav .utility-duplicate {display:none}
.dashboard-shell .leftNav > ul.utility-nav > li {
  width:128px;
  min-height:46px;
}
.dashboard-shell .leftNav > ul.utility-nav > li > a {
  position:relative;
  width:124px;
  height:46px;
  border-radius:10px;
}
.dashboard-shell .leftNav > ul.utility-nav > li > a em {
  width:30px;
  height:42px;
  flex:0 0 30px;
  background-size:19px;
  opacity:.62;
}
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a {
  border:1px solid rgba(189,163,111,.4);
  background:rgba(138,112,66,.13);
  box-shadow:none;
}
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a em,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a em {opacity:1}
.dashboard-shell .leftNav > ul.utility-nav > li > a::after {
  display:none;
}
.dashboard-shell .leftNav > ul > li {
  width: 128px;
  min-height: 58px;
}
.dashboard-shell .leftNav > ul > li::after {
  display: none;
}
.dashboard-shell .leftNav > ul > li > a {
  width: 124px;
  height: 58px;
  margin: 0 auto;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #aaa6a0;
  font-size: 11px;
  justify-content: flex-start;
  gap: 8px;
}
.dashboard-shell .leftNav > ul > li:hover > a,
.dashboard-shell .leftNav > ul > li > a.on {
  border-color: rgba(214, 174, 89, .55);
  background: linear-gradient(145deg, #2b251a, #17181e);
  box-shadow: 0 9px 22px rgba(0, 0, 0, .25);
}
.dashboard-shell .leftNav > ul > li > a em {
  width: 30px;
  height: 42px;
  flex: 0 0 30px;
}
.dashboard-shell .leftNav .dropdown-toggle i {
  display: none;
}
.dashboard-shell .leftNav .dropdown-menu {
  position: absolute;
  left: 136px;
  top: 0;
  z-index: 30;
  width: 230px;
  max-height: 420px;
  padding: 10px;
  overflow-y: auto;
  border: 1px solid #343640;
  border-radius: 14px;
  background: rgba(17, 19, 26, .98);
  box-shadow: 18px 20px 45px rgba(0, 0, 0, .48);
  backdrop-filter: blur(15px);
}
.dashboard-shell .leftNav .dropdown-menu > ul,
.dashboard-shell .leftNav .dropdown-menu li {
  display: block;
}
.dashboard-shell .leftNav .dropdown-menu a {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border-radius: 9px;
  box-sizing: border-box;
  color: #b9bbc4;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.dashboard-shell .leftNav .dropdown-menu a:hover {
  color: #edcd82;
  background: #25221d;
}
.dashboard-shell .leftNav .dropname {
  overflow: hidden;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* MEGA muted editorial theme */
.dashboard-shell {
  --mega-bg: #0c0d0f;
  --mega-surface: #141516;
  --mega-surface-raised: #1b1c1d;
  --mega-border: #303032;
  --mega-primary: #8a7042;
  --mega-primary-bright: #bda36f;
  --mega-secondary: #7d796e;
  --mega-text: #e9e6e1;
  --mega-muted: #8d8a84;
  min-height: 100vh;
  background: #0c0c0e !important;
}
.dashboard-root {min-height:100vh;background:#0c0c0e !important}
body.mega09-editorial-body {
  min-width:320px;
  background:#0b0b0c;
}
.dashboard-root,
.dashboard-shell,
.dashboard-shell .content0 {
  min-width:0;
  max-width:100%;
  box-sizing:border-box;
}
.dashboard-root,
.dashboard-shell {width:100%}
.dashboard-shell .content0 {flex:1 1 auto}
.dashboard-shell .leftHeader {
  background:
    radial-gradient(circle at 50% 9%, rgba(154, 123, 69, .12), transparent 24%),
    linear-gradient(180deg, #161617 0%, #0c0d0e 100%);
  border-right-color: #2a2929;
}
.dashboard-shell .leftHeader .logowrap a {
  border-color: rgba(189, 163, 111, .46);
  background: linear-gradient(145deg, #2b271f, #171718);
  box-shadow: inset 0 0 18px rgba(138, 112, 66, .1), 0 10px 28px rgba(0, 0, 0, .3);
}
.dashboard-shell .leftHeader .logowrap a::after {
  color: var(--mega-primary-bright);
  text-shadow: 0 2px 12px rgba(0, 0, 0, .48);
}
.dashboard-shell .leftNav > ul > li > a em {
  opacity: .66;
  filter: grayscale(1) brightness(1.7);
  transition: opacity .2s, filter .2s;
}
.dashboard-shell .leftNav > ul > li:hover > a,
.dashboard-shell .leftNav > ul > li > a.on {
  border-color: rgba(189, 163, 111, .42);
  background: linear-gradient(145deg, rgba(138, 112, 66, .19), #1a1a1b 72%);
  box-shadow: inset 0 0 16px rgba(138, 112, 66, .06), 0 10px 24px rgba(0, 0, 0, .28);
}
.dashboard-shell .leftNav > ul > li:hover > a em,
.dashboard-shell .leftNav > ul > li > a.on em {
  opacity: 1;
  filter: grayscale(1) brightness(2.2);
}
.dashboard-shell .leftNav .dropdown-menu {
  border-color: #383637;
  background: rgba(20, 20, 21, .98);
  box-shadow: 20px 24px 48px rgba(0, 0, 0, .48), 0 0 0 1px rgba(138, 112, 66, .05);
}
.dashboard-shell .leftNav .dropdown-menu a:hover {
  color: #d4c29b;
  background: linear-gradient(90deg, rgba(138, 112, 66, .22), rgba(125, 121, 110, .07));
}
.dashboard-shell .leftNav > ul > li > a,
.dashboard-shell .leftNav > ul.utility-nav > li > a {
  position: relative;
  overflow: hidden;
  border-color: transparent;
  border-radius: 6px;
  background: transparent;
  box-shadow: none;
}
.dashboard-shell .leftNav > ul > li > a::before,
.dashboard-shell .leftNav > ul.utility-nav > li > a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 11px;
  bottom: 11px;
  width: 2px;
  background: #b6a06a;
  opacity: 0;
  transition: opacity .18s;
}
.dashboard-shell .leftNav > ul > li:hover > a,
.dashboard-shell .leftNav > ul > li.on > a,
.dashboard-shell .leftNav > ul > li > a.on,
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a {
  border-color: transparent;
  background: #171718;
  box-shadow: none;
}
.dashboard-shell .leftNav > ul > li:hover > a::before,
.dashboard-shell .leftNav > ul > li.on > a::before,
.dashboard-shell .leftNav > ul > li > a.on::before,
.dashboard-shell .leftNav > ul.utility-nav > li:hover > a::before,
.dashboard-shell .leftNav > ul.utility-nav > li.on > a::before {
  opacity: 1;
}
.dashboard-shell .head_info {
  background: #101112;
  border-bottom: 1px solid #282728;
}
.dashboard-shell .topbannerin span {
  color: #c7c8cf;
}
.dashboard-shell .coninpoint {
  border-color: rgba(189, 163, 111, .42);
  background: rgba(43, 37, 27, .88);
  box-shadow: inset 0 0 16px rgba(138, 112, 66, .06), 0 8px 22px rgba(0, 0, 0, .24);
}
.dashboard-shell .coninpoint li span {
  color: #c8b17f;
}
.dashboard-shell .headerbtn {
  border-color: rgba(189, 163, 111, .48);
  background: linear-gradient(135deg, #5b492b, #8a7042);
  color: #f1ece9;
}

/* MEGA shared subpage layout */
.subpage-shell .content0.sub {
  min-height: 100vh;
  padding: 88px 24px 72px;
  background: #0c0c0e;
  color: #eeeae6;
  box-sizing: border-box;
}
.subpage-shell .w1260,
.subpage-shell .w900 {width:min(1260px,100%);margin-right:auto;margin-left:auto}
.subpage-shell .snavi {display:none}
.subpage-shell .subBanner {
  min-height:44px;
  margin:0 0 16px;
  gap:10px;
  color:#eeeae6;
  font-size:24px;
  font-weight:700;
  letter-spacing:-.03em;
}
.subpage-shell .subBanner img {width:22px;height:22px;opacity:.75}
.subpage-shell .navSide {margin:0 0 20px}
.subpage-shell .boardnav {
  height:48px;
  gap:26px;
  border-bottom:1px solid #29292d;
  align-items:stretch;
}
.subpage-shell .boardnav>li {width:auto}
.subpage-shell .boardnav>li>span {
  position:relative;
  min-width:120px;
  height:48px;
  padding:0 2px;
  border:0;
  background:transparent;
  color:#8f8b87;
  font-size:12px;
}
.subpage-shell .boardnav>li.on>span,
.subpage-shell .boardnav>li:hover>span {border:0;background:transparent;color:#eeeae6}
.subpage-shell .boardnav>li.on>span::after {
  content:'';
  position:absolute;
  right:0;
  bottom:-1px;
  left:0;
  height:2px;
  background:#a98d57;
}
.subpage-shell .boardwrap {
  gap:16px;
  margin-bottom:48px;
  padding:0;
  border:0;
  border-radius:0;
  background:transparent;
  box-shadow:none;
}
.subpage-shell .moneyread,
.subpage-shell .mybetwrap,
.subpage-shell .board {
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
  box-shadow:none;
}
.subpage-shell .moneyread {padding:22px 24px}
.subpage-shell .moneyread h3 {color:#d5c39c;font-size:14px;font-weight:600}
.subpage-shell .moneyread ul li {color:#aaa6a1;font-size:11px;line-height:1.8}
.subpage-shell .mybetwrap {padding:24px}
.subpage-shell .moneyinfo {padding:0 0 18px;border:0;border-bottom:1px solid #29292d}
.subpage-shell .applih {color:#d0b87f;font-size:13px}
.subpage-shell .applip {color:#817e79;font-size:11px}
.subpage-shell .appliinputwrap {display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 20px;padding-top:4px}
.subpage-shell .appliinputwrap>ul {margin-top:14px}
.subpage-shell .appliinput {width:100%;gap:8px;color:#c9c5c0;font-size:11px}
.subpage-shell .appliinput li {width:100%}
.subpage-shell .appliinput li:nth-child(2) {
  height:42px;
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  box-shadow:none;
}
.subpage-shell .moneybtnwrap {grid-column:1/-1;flex-wrap:wrap}
.subpage-shell .moneybtnwrap a {border:1px solid #343334;border-radius:6px;background:#1b1b1d;color:#bbb6b0}
.subpage-shell .moneybtnwrap li:hover a {border-color:#8a7042;color:#e2d4b5}
.subpage-shell .applibtns a,
.subpage-shell .blsbtn {border:1px solid #8a7042;border-radius:7px;background:#8a7042;color:#f5f1e9;box-shadow:none}
.subpage-shell .board {overflow:hidden}
.subpage-shell .board>.boardw.first:first-child,
.subpage-shell .boardw,
.subpage-shell .wblbg.boardw,
.subpage-shell .wywbg.boardw {
  border:0;
  border-bottom:1px solid #29292d;
  background:#141416;
  color:#c9c5c0;
}
.subpage-shell .board>.boardw.first:first-child {background:#101012;color:#8f8b87}
.subpage-shell .boardw:hover {background:#1b1b1e}
.subpage-shell .boardw:last-child {border-bottom:0}
.subpage-shell .boardw li {font-size:11px}
.subpage-shell .boardw .bkc,
.subpage-shell .boardw .ywc {color:#d8d2ca}
.subpage-shell .moneyinfoappli {
  padding:24px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.subpage-shell .moneyinfoappli .moneyinfo {margin-bottom:4px}
.subpage-shell .applibtn {
  width:auto;
  height:34px;
  margin-top:12px;
  padding:0 14px;
  border:1px solid #5f5137;
  border-radius:6px;
  background:#211e18;
  color:#cdbb92;
  text-shadow:none;
}
.subpage-shell .applistep {color:#8f8b87}
.subpage-shell .applistep li {color:#8f8b87;font-size:11px}
.subpage-shell .applistep strong {color:#d0bc91}
.subpage-shell .applibtns {margin:18px 0 28px;text-align:right}
.subpage-shell .applibtns a {display:inline-flex;min-width:120px;height:40px;padding:0 22px;align-items:center;justify-content:center;box-sizing:border-box}
.subpage-shell .moneyreadWrap {margin-top:20px;padding:0}
.subpage-shell .rollName {
  margin:16px 0 10px;
  padding:14px 16px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  color:#98938d;
  font-size:11px;
  line-height:1.6;
}
.subpage-shell .rollName span {color:#d0bc91}
.subpage-shell .pointlist {
  display:grid;
  grid-template-columns:repeat(4,minmax(0,1fr));
  gap:8px;
  margin:0 0 16px;
}
.subpage-shell .pointlist>li {
  padding:14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  color:#aaa6a1;
}
.subpage-shell .pointlist .rolling {color:#d0bc91}
.subpage-shell .datesearch {
  display:flex;
  align-items:flex-end;
  gap:12px;
  margin-bottom:16px;
  padding:14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
}
.subpage-shell .datesearch>select,
.subpage-shell .searchselect,
.subpage-shell .searchinput,
.subpage-shell .boardwrt input,
.subpage-shell .boardwrt select,
.subpage-shell .boardwrt textarea,
.subpage-shell .joinu input {
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  color:#eeeae6;
  box-shadow:none;
}
.subpage-shell .datesearch>select {min-width:170px;height:40px;padding:0 10px}
.subpage-shell .datewrap {border-color:#302f30;background:#101012;box-shadow:none}
.subpage-shell .datewrap input,
.subpage-shell .datewrap select {border-color:#302f30;background:#141416;color:#ddd8d2}
.subpage-shell .searchwrap {margin:0 0 16px}
.subpage-shell .searchselect,
.subpage-shell .searchinput {height:38px}
.subpage-shell .searchicon {height:38px;border:1px solid #8a7042;border-radius:6px;background:#8a7042;color:#f5f1e9;text-shadow:none}
.subpage-shell .box {
  padding:20px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.subpage-shell .box .board {border-radius:7px}
.subpage-shell .boardbtn {margin-top:16px}
.subpage-shell .boardbtn a,
.subpage-shell .boardbtn button,
.subpage-shell .grbbtn,
.subpage-shell .grsbtn,
.subpage-shell .rdsbtn02 {
  min-height:34px;
  padding:0 14px;
  border:1px solid #4a4743;
  border-radius:6px;
  background:#1b1b1d;
  color:#c8c2bb;
  box-shadow:none;
  text-shadow:none;
}
.subpage-shell .boardbtn a:hover,
.subpage-shell .boardbtn button:hover,
.subpage-shell .grbbtn:hover {border-color:#8a7042;color:#e1d1ad}
.subpage-shell .mybetwrap .tab-content {color:#c9c5c0}
.subpage-shell .joinu {gap:8px}
.subpage-shell .joinu li:first-child {color:#aaa6a1;font-size:11px}
.subpage-shell .joinu li+li,
.subpage-shell .joinu li.myfix_id {
  width:100%;
  height:42px;
  padding:0 13px;
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  color:#eeeae6;
  box-sizing:border-box;
}
.subpage-shell .joinu input {height:40px;padding:0;width:100%}
.subpage-shell .joinubottom {
  margin:16px 0 24px;
  padding:14px 18px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
}
.subpage-shell .joinubottom .joinub {width:100%;padding:7px 0;border-bottom:1px solid #29292d}
.subpage-shell .joinubottom .joinub:last-child {border-bottom:0}
.subpage-shell .detailPop,
.subpage-shell .betlist-content {
  border:1px solid #3a3838;
  border-radius:8px;
  background:#141416;
  color:#eeeae6;
  box-shadow:0 24px 60px rgba(0,0,0,.5);
}
.subpage-shell .detailPop h4,
.subpage-shell .betlist-title {border-bottom:1px solid #302f30;background:#181819;color:#d8c69f}
@media (max-width:900px) {
  .subpage-shell .content0.sub {padding-right:14px;padding-left:14px}
  .subpage-shell .appliinputwrap {grid-template-columns:1fr}
  .subpage-shell .pointlist {grid-template-columns:repeat(2,minmax(0,1fr))}
}
</style>
